import * as React from 'react';
import { Page as PaymentFormPage } from './pages/payment_form';
export const PaymentFormFunnel = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PaymentFormPage, null));
};